import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AboutHero from '../components/about/AboutHero';
import OurStory from '../components/about/OurStory';
import TeamSection from '../components/about/TeamSection';
import PartnersSection from '../components/about/PartnersSection';
import SEO from '../components/SEO';
import {
  organization,
  breadcrumb,
  wrap,
  SITE_URL,
} from '../components/seo/schemas';
import { Toaster } from '../components/ui/toaster';

const PAGE_URL = `${SITE_URL}/about`;

const arjun = {
  '@type': 'Person',
  '@id': `${PAGE_URL}#arjun-bhatt`,
  name: 'Arjun Bhatt',
  jobTitle: 'Founder',
  worksFor: { '@id': `${SITE_URL}/#organization` },
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Oslo',
    addressCountry: 'NO',
  },
  sameAs: ['https://www.linkedin.com/in/arjunbhatt/'],
};

const structuredData = wrap([
  organization,
  arjun,
  breadcrumb([
    { name: 'Home', url: SITE_URL },
    { name: 'About', url: PAGE_URL },
  ]),
  {
    '@type': 'AboutPage',
    '@id': `${PAGE_URL}#aboutpage`,
    url: PAGE_URL,
    name: 'About Upscale — Growth Marketing Team in Oslo',
    description:
      'Upscale is a growth marketing agency founded by Arjun Bhatt out of YM:R startup studio. Team and partners helping startups scale across Norway, India and UK.',
    inLanguage: 'en',
    mainEntity: { '@id': `${SITE_URL}/#organization` },
    about: [arjun, { '@id': `${SITE_URL}/#organization` }],
  },
]);

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="About Upscale | Growth Marketing Team & Partners - Oslo, Norway"
        description="Learn about Upscale, a growth marketing agency founded by Arjun Bhatt from YM:R startup studio. Meet our experienced team and partners. Helping startups scale in Norway, India, and UK since 2023."
        keywords="Upscale team, Arjun Bhatt, YM:R startup studio, growth hacker Oslo, marketing team Norway, startup advisors, growth consultants, Ymir Labs"
        canonicalUrl={PAGE_URL}
        ogTitle="About Upscale — The team behind data-driven startup growth"
        ogDescription="Founded by Arjun Bhatt out of YM:R startup studio. Meet the Oslo-based team scaling startups across Norway, India and the UK."
        structuredData={structuredData}
      />
      <Navbar />
      <AboutHero />
      <OurStory />
      <TeamSection />
      <PartnersSection />
      <Footer />
      <Toaster />
    </div>
  );
};

export default AboutPage;
